import { render } from "./CategoriasApi.vue?vue&type=template&id=72a56e49"
import script from "./CategoriasApi.vue?vue&type=script&lang=js"
export * from "./CategoriasApi.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__